export const publicPaths = {
  home: "/",
  pricing: "/pricing",
  demoLayout: "/layout",
  previewPricing: "/preview-pricing",

  quicksightDashboardEmbeded: "/quicksight-dashboard-embeded",
};

export const privatePaths = {
  transactionLogs: '/transaction-logs',
  adminDashboard: '/admin-dashboard',
  adminUserManagement: '/admin-user-management',
  // quicksightDashboard: '/quicksight-dashboard'
};
